import Vue from 'vue'
import { GridPlugin } from '@syncfusion/ej2-vue-grids';

Vue.use(GridPlugin);



